let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kSBuO")).then(() => parcelRequire('dw9fw'));